<template>
  <path
    d="M15.65 3.646a.5.5 0 0 1 .765.638l-.057.07L8.707 12l7.65 7.646a.5.5 0 0 1 .059.638l-.058.07a.5.5 0 0 1-.638.057l-.07-.057-8.003-8a.5.5 0 0 1-.058-.638l.058-.07 8.004-8z"
    fill="#010A0D"
    fill-rule="nonzero"
  />
</template>
